import Request from './request';

export default class BonusService {
    static instance() {
        if (this._instance) {
            return this._instance;
        }
        return this._instance = new BonusService();
    }

    searchBonus(search) {
        let page = search.page || 0;
        let size = search.size || 20;

        return Request.instance().post('/console/v1/bonus', { page, size });
    }

    getBonusById(id) {
        return Request.instance().get(`/console/v1/bonus/${id}`);
    }

    editBonus(payload) {
        return Request.instance().post('/console/v1/bonus/save', payload);
    }

    deleteBonus(id) {
        return Request.instance().delete(`/console/v1/bonus/${id}`);
    }
}